import * as React from 'react';
import { ProductionEnvironment } from '../environment';
import { createDocumentReference as createDocPrepDocumentReference } from '../apis/prepress';
import { createBareDocumentReference } from '../apis/uploads';
import { PlatformProcessor } from './UploaderProcessor';
import { DispatchCheckbox } from './DispatchCheckbox';
import { useDoubleTTranslation } from '../hooks/i18n';
import { MultilineTranslation } from './MultilineTranslation';
import { Accordion } from '@cimpress/react-components';
const defaultUploadSettings = {
    useDocPrep: true
};
const uploadSettingsReducer = (state, action) => {
    switch (action.type) {
        case 'useDocPrep':
            return Object.assign(Object.assign({}, state), { useDocPrep: !state.useDocPrep });
        default:
            return state;
    }
};
export const FileArtworkSelector = props => {
    const [uploadSettings, uploadSettingsDispatch] = React.useReducer(uploadSettingsReducer, defaultUploadSettings);
    const [areSettingsLocked, setAreSettingsLocked] = React.useState(false);
    const { tt } = useDoubleTTranslation(props.language);
    const handleUploadStart = () => {
        setAreSettingsLocked(true);
    };
    const handleError = () => {
        setAreSettingsLocked(false);
    };
    const handleDelete = () => {
        props.onChange(undefined);
        setAreSettingsLocked(false);
    };
    const process = (uploadedImage) => {
        const createDocumentReferenceFunction = uploadSettings.useDocPrep
            ? () => createDocPrepDocumentReference(props.environment.prepressBaseUrl, props.accessToken, uploadedImage[0]._links.self.href, props.productConfig)
            : () => createBareDocumentReference(props.accessToken, uploadedImage[0]._links.self.href, 'mcp-commerce-order-placement');
        return createDocumentReferenceFunction()
            .then(docRefUrl => {
            props.onChange({ documentReferenceUrl: docRefUrl });
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("form", null,
            React.createElement(PlatformProcessor, { process: process, accessToken: props.accessToken, uploadOptions: { uploadTenant: 'mcp-commerce-order-placement', provideThumbnails: true }, onUploadStart: handleUploadStart, onError: handleError, onDelete: handleDelete }),
            React.createElement(Accordion, { title: tt('fileArtworkSelector.settingsSectionTitle') },
                React.createElement(DispatchCheckbox, { state: uploadSettings, id: 'useDocPrep', dispatch: uploadSettingsDispatch, disabled: areSettingsLocked, label: tt('fileArtworkSelector.checkboxes.useDocPrep.label'), tooltipContents: (React.createElement(MultilineTranslation, { t: tt, translationKey: 'fileArtworkSelector.checkboxes.useDocPrep.tooltip' })) })))));
};
FileArtworkSelector.defaultProps = {
    environment: ProductionEnvironment
};
//# sourceMappingURL=FileArtworkSelector.js.map